import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@mui/material';
import { useSelector } from 'react-redux';

import HeadToHeadFilters from './filters/HeadToHeadFilters';
import HeadToHeadDisclaimer from './disclaimer/HeadToHeadDisclaimer';
import HeadToHeadCharts from './charts/HeadToHeadCharts';

import scss from './HeadToHead.module.scss';

function HeadToHead() {
  const { t } = useTranslation('resonance');

  const isProjectLoading = useSelector((state) => state.resonance.isProjectLoading);

  const [topMessage, setTopMessage] = useState(null);
  const [selectedMessages, setSelectedMessages] = useState([]);

  const handleSelectMessage = (messages) => {
    setSelectedMessages(messages);
  };

  const isMessagesSelected = topMessage?.value && selectedMessages.length;

  return isProjectLoading ? (
    <Skeleton animation='wave' variant='rounded' height={430} />
  ) : (
    <div className={scss.section}>
      <div className={scss.sectionHeader}>
        <h3 className={scss.title}>{t('headToHead')}</h3>
        <HeadToHeadFilters
          topMessage={topMessage}
          selectedMessages={selectedMessages}
          onChangeTopMessage={setTopMessage}
          onSelectMessage={handleSelectMessage}
        />
      </div>
      <div className={scss.sectionContent}>
        {!isMessagesSelected ? (
          <HeadToHeadDisclaimer topMessage={topMessage?.value} selectedMessages={selectedMessages} />
        ) : (
          <HeadToHeadCharts topMessage={topMessage} selectedMessages={selectedMessages} />
        )}
      </div>
    </div>
  );
}

export default HeadToHead;
